import { type SanityShoppingInfo } from '@data/sanity/queries/types/site'

import Accordion from '@components/accordion'
import SimplePortableText from '@components/simple-portable-text'

interface ProductShoppingInfoProps {
  shoppingInfo?: SanityShoppingInfo
}

const ProductShoppingInfo = ({ shoppingInfo }: ProductShoppingInfoProps) => {
  if (!shoppingInfo?.content) {
    return
  }

  return (
    <div>
      {shoppingInfo.content.map((item, index) => (
        <Accordion
          id={`shopping-info-${index}-${item._key}`}
          key={`${item._key}-${index}`}
          title={item.title}
          variant="content"
        >
          <SimplePortableText
            content={item.content}
            className="rc rc-accordion"
          />
        </Accordion>
      ))}
    </div>
  )
}

export default ProductShoppingInfo
